<template>
  <div>
    <v-container fluid class="py-0">
    <v-row>
      <v-card flat color="transparent" class="mx-auto py-6 text-center" >
        <v-card-title class="display-1 mb-2">{{ city.name }}</v-card-title>
        <v-card-subtitle class="font-weight-regular title mb-2">{{ city.englishName }}</v-card-subtitle>
      </v-card>
    </v-row>
    <v-row > 
      <v-col cols="12" sm=6 class="ma-0 pa-0">
        <v-card flat color="amber lighten-5" class="fill-height" >
          <v-row align="center" class="fill-height pa-0  ma-0">
            <v-col class="d-none d-sm-flex" cols=3></v-col>
            <v-col>
              <v-card-title>{{ city.fullName }}</v-card-title>
              <v-card-text v-if="city.address" class="py-0 subtitle-1">{{ $t('about.company_access.address')+"："+city.address }}</v-card-text>
              <v-card-text v-if="city.phone" class="py-0 subtitle-1">{{ $t('about.company_access.phone')+"："+city.phone }}</v-card-text>
              <v-card-text v-if="city.fax" class="py-0 subtitle-1">{{ $t('about.company_access.fax')+"："+city.fax }}</v-card-text>
              <v-card-text v-if="city.postcode" class="py-0 subtitle-1">{{ $t('about.company_access.postcode')+"："+city.postcode }}</v-card-text>
              <v-card-text v-if="city.email" class="py-0 subtitle-1">{{ $t('about.company_access.email')+"："+city.email }}</v-card-text>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
      <v-col cols="12" sm="6" class="ma-0 pa-0">
        <v-img :src="city.imageUrl"></v-img>
      </v-col>
    </v-row>
  </v-container>  
  <tci-contact-footer color="white"></tci-contact-footer>
  </div>
</template>

<script>
import TciContactFooter from "@/components/TciContactFooter.vue";

export default {
  name: "CompanyAddress",
  components: {
    "tci-contact-footer": TciContactFooter
  },
  data: () => ({
    citys: [
      {"name":"​苏州大宇宙","englishName":"Suzhou","fullName":"苏州大宇宙信息创造有限公司","address":"江苏省苏州工业园区集贤街68号","phone":"86-512-8666-5570","fax":"86-512-8666-5571","postcode":"215123","email":"suzhou@trans-cosmos.com.cn","imageUrl":require('../assets/companyAccess/suzhou.jpg')},
      {"name":"​苏州大宇宙　常州分公司","englishName":"Changzhou","fullName":"苏州大宇宙信息创造有限公司 常州分公司","address":"江苏省常州市新北区太湖东路9号 常州创意产业园D栋821室","phone":"86-519-83862283","postcode":"213022","imageUrl":require('../assets/companyAccess/changzhou.jpg')},
      {"name":"苏州大宇宙　上海分公司","englishName":"​Shanghai","fullName":"苏州大宇宙信息创造有限公司 上海分公司","address":"上海市曹杨路619号近铁云中心5楼G座","phone":"86-21-5282-1972","postcode":"200333","imageUrl":require('../assets/companyAccess/shanghai.jpg')}
    ],
    magazines: [
      {"year":"2019","imageUrl":[require('../assets/company/c5201901-1.jpg')]},
      {"year":"2018","imageUrl":[require('../assets/company/c5201812-1.jpg')]},
      {"year":"2018","imageUrl":[require('../assets/company/c5201811-1.jpg')]},
      {"year":"2018","imageUrl":[require('../assets/company/c5201809-1.jpg'),require('../assets/company/c5201809-2.jpg')]},
      {"year":"2017","imageUrl":[require('../assets/company/c5201704-1.jpg'),require('../assets/company/c5201704-2.jpg')]},
    ],
    city: {}
  }),
  mounted(){
    this.city = this.citys[this.$route.params.id-1]
  }
};
</script>
